import React from "react";

/**
 * Renders a rich-text field authored in CKEditor exactly as it was written —
 * links, lists and formatting come from the editor, we do not invent them.
 *
 * Fields migrated from plain <textarea> still contain rows of bare text with
 * "\n" line breaks. Those have no tags at all, so they are rendered with
 * white-space: pre-line to keep their line breaks; anything containing markup
 * is rendered as HTML.
 *
 * Images uploaded via CKEditor are stored with relative paths (e.g.
 * /uploads/image.png). We rewrite those to absolute URLs pointing at the
 * Strapi backend so they load correctly on the frontend.
 */

const API_URL = process.env.REACT_APP_API_URL || "";

/**
 * Prepend API_URL to relative src / srcset values inside <img> tags so that
 * images served by Strapi resolve correctly on the frontend domain.
 */
function rewriteImageUrls(html) {
  if (!API_URL || !html) return html;

  // Rewrite src="/<path>" (but not src="http..." or src="//...")
  let result = html.replace(
    /(<img\b[^>]*\bsrc=["'])\/(?!\/)/gi,
    `$1${API_URL}/`,
  );

  // Rewrite srcset values (e.g. srcset="/uploads/img_small.png 300w, ...")
  result = result.replace(
    /(<img\b[^>]*\bsrcset=["'])([^"']+)(["'])/gi,
    (_match, prefix, value, suffix) => {
      const fixed = value.replace(
        /(^|,\s*)\/(?!\/)/g,
        `$1${API_URL}/`,
      );
      return prefix + fixed + suffix;
    },
  );

  return result;
}

export default function RichText({ html, className = "" }) {
  if (!html) return null;

  const isHtml = /<[a-z][\s\S]*>/i.test(html);
  const processed = isHtml ? rewriteImageUrls(html) : html;

  return (
    <div
      className={
        `content-html text-left ${isHtml ? "" : "legacy-linebreaks"} ` + className
      }
      dangerouslySetInnerHTML={{ __html: processed }}
    />
  );
}
